import React from 'react'
import { Can } from 'components/Permissions'
import { TitleStyles } from './Style'
import { useNavigate } from 'react-router-dom'

const Title = (props) => {
    const { feature, title, children, featurePath, breadcrumbs } = props

    const navigate = useNavigate()

    return (
        <TitleStyles breadcrumbs={breadcrumbs}>
            <Can I="read" a={`${feature}-title`}>
                <h1>
                    <div className='title' onClick={() => breadcrumbs && navigate(`/${featurePath}`)}>{title}</div>
                    <div>
                        {children}
                    </div>
                </h1>
            </Can>
        </TitleStyles>
    )
}

export default Title